<template>
  <list-item
    :link="{ name: 'requests.show', params: { id: booking.id } }"
    :booking="booking"
  >
    <template v-slot:title>
      {{ booking.name }} &ndash; <span class="text-primary">{{ booking.budget_per_star_as_user_rate | currency(booking.currency) }}</span>
    </template>
    <template v-slot:admin></template>
    <template v-slot:hero>Respond</template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'
import MetaItem from '../list/meta/MetaItem'
import MetaDate from '../list/meta/MetaDate'
import MetaDue from '../list/meta/MetaDue'

export default {
  mixins: [helpers],
  components: {
    ListItem,
    MetaItem,
    MetaDate,
    MetaDue
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  }
}
</script>
